// store/slices/filterSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { format, subDays } from 'date-fns';

const initialState = {
  selectedVoyage: null,
  dateRange: {
    startDate: format(subDays(new Date(), 30), 'yyyy-MM-dd'),
    endDate: format(new Date(), 'yyyy-MM-dd')
  }
};

const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
  setSelectedVoyage: (state, action) => {
    state.selectedVoyage = action.payload;

    if (action.payload) {
      const { departTime, arriveTime } = action.payload;

      const safeDate = (date) => {
        if (!date) return null;
        const parsed = new Date(date);
        return isNaN(parsed.getTime()) ? null : parsed;
      };

      const depart = safeDate(departTime);
      const arrive = safeDate(arriveTime);

      state.dateRange = {
        startDate: depart ? format(depart, 'yyyy-MM-dd') : state.dateRange.startDate,
        endDate: arrive ? format(arrive, 'yyyy-MM-dd') : state.dateRange.endDate,
      };
    }
  },
    setDateRange: (state, action) => {
      state.dateRange = action.payload;
      state.selectedVoyage = null;
    },
    clearFilters: (state) => {
      state.selectedVoyage = null;
      state.dateRange = initialState.dateRange;
    },
    clearSelectedVoyage: (state) => {
      state.selectedVoyage = null;
    }
  }
});

export const { setSelectedVoyage, setDateRange, clearFilters, clearSelectedVoyage  } = filterSlice.actions;
export default filterSlice.reducer;